import { useState, useEffect } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import moment from "moment";

const CustomDatePicker = ({ onDateChange, valueStart, valueEnd }) => {
    const [value, setValue] = useState({
        startDate: valueStart || null,
        endDate: valueEnd || null,
    });

    useEffect(() => {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
        setValue({
            startDate: startOfMonth,
            endDate: endOfMonth,
        });
    }, []);

    const handleChange = (newValue) => {
        setValue(newValue);
        if (onDateChange) {
            onDateChange(newValue.startDate, newValue.endDate);
        }
    };

    return (
        <Datepicker
            i18n={"it"}
            startWeekOn="mon"
            separator=" - "
            displayFormat="DD/MM/YYYY"
            primaryColor={"indigo"}
            value={value}
            onChange={handleChange}
        />
    );
};

export default CustomDatePicker;
